<style lang="less" scoped>
  @import "../../../style/theme.less";

  #user-layout {
    min-height: 100vh;
    background: linear-gradient(0deg, fade(@blue-1, 50%), fade(@blue-1, 50%)), url(../../../assets/background.jpg) center left / cover no-repeat;

    .content {
      border-radius: @border-radius-base;
      padding: 32px 32px 24px 32px;
      background: @component-background;
      max-width: 80%;
      max-height: 80%;
      overflow-y: auto;
      left: 50%;
      top: 10%;
      transform: translateX(-50%);
      position: absolute;
      transition: all .5s @ease-in-out;

      img {
        width: 80%;
        max-width: 400px;
        position: relative;
      }
    }
  }

  @media only screen and (max-width: 550px) {
    #user-layout {
      background: @component-background;

      .content {
        max-width: 100%;
        min-width: 100%;
        max-height: none;
        position: relative;
        left: 0;
        top: 0;
        transform: translateX(0%);
        border-radius: 0;
      }
    }
  }
</style>

<style lang="less">
  #user-layout .content {
    text-align: center;
  }
</style>

<template>
  <a-layout id="user-layout">
    <a-page-header
      sub-title="Return to GoddessGift.com"
      @back="returnToHomepage"
      @click="returnToHomepage"
    />
      <a-layout-content class="content" :style="modalStyle">
        <img src="../../../assets/logo_wide_dark.png" :style="logoStyle"/>
        <div class="spacer-lg" />
        <a-alert v-if="error.show" :message="error.message" type="info" show-icon style="margin-bottom: 16px;" />
        <vue-page-transition name="fade-in-left">
          <router-view />
        </vue-page-transition>
      </a-layout-content>
  </a-layout>
</template>

<script>

import { mapState } from 'vuex';

export default {
  data: () => ({
    report: false,
    questions: false,
    modalStyle: {
      width: '500px',
    },
    logoStyle: {
      width: '80%',
    },
  }),

  mounted() {
    this.updateStyles(this.$route.name);
  },

  watch: {
    $route(route) {
      this.updateStyles(route.name);
    },
  },

  computed: mapState('user', ['error',]),

  methods: {
    updateStyles(routeName) {
      this.modalStyle = {
        'user.report': { width:'80%', },
        'user.landing': { width: '700px', },
        'user.questions': { width: '600px', top: '5%', maxHeight: '90%', },
      }[routeName] || { width: '500px', };

      this.logoStyle.width = {
        'user.questions': '60%',
      }[routeName] || '80%';
    },

    returnToHomepage() {
      return window.location = 'https://goddessgift.com';
    },
  },
};
</script>
